import { 
    FaXTwitter, FaLinkedin, FaInstagram,
    FaEnvelope, FaFacebook, FaGithub
} from "react-icons/fa6";

export default function Share() {
    const url = window.location.href;

    const socialLinks = [
        {
            component: <FaLinkedin size={24} />,
            action: () => {
                window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank');
            }
        },
        {
            component: <FaGithub size={24} />,
            action: () => {
                window.open(`https://github.com/new?body=${url}`, '_blank');
            }
        },
        {
            component: <FaXTwitter size={24} />,
            action: () => {
                const title = encodeURIComponent('Check out this blog:');
                window.open(`https://twitter.com/intent/tweet?url=${url}&text=${title}`, '_blank');
            }
        },
        {
            component: <FaInstagram size={24} />,
            action: () => {
                alert('Instagram sharing is not supported directly from the browser.');
            }
        },
        {
            component: <FaEnvelope size={24} />,
            action: () => {
                const subject = encodeURIComponent('Check out this blog:');
                window.location.href = `mailto:?subject=${subject}&body=${url}`;
            }
        },
        {
            component: <FaFacebook size={24} />,
            action: () => {
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
            }
        },
    ]

  return (
    <div className="mx-4 my-3 flex flex-row items-center justify-center space-x-4">
        <p className="text-white black-ops-font">Share this blog on: </p>
        {socialLinks.map((link, index) => (
            <p key={index} onClick={link.action} 
                className="text-white hover:text-blue-600 mr-4" 
                target="_blank" rel="noreferrer"
            >
                {link.component}
            </p>
        ))}
    </div>
  )
}
